export default "__VITE_ASSET__DmmOxc0k__"